/**
 * Created by andrey on 23.12.2022
 */

const RestPayments = function (name, options = {}) {
    Payments.call(this, name, options);

    this.source = options.source || connector.info.source;
};

RestPayments.prototype = Object.create(Payments.prototype);
RestPayments.prototype.constructor = RestPayments;

RestPayments.prototype.purchase = function (product, callback) {
    const purchase = this.createPurchase(undefined, product);

    this.startPurchasePinger(purchase, callback, {
        timeoutCode: ERRORS.PURCHASE.TIMEOUT
    });

    this.purchaseOpen(product, callback);
};

RestPayments.prototype.purchaseOpen = function (product, callback) {
    callback(connector.CODE_FAILED);
};

RestPayments.prototype.restore = function (callback) {
    const path = `/payments/restore/${this.source}/${encodeURIComponent(connector.platform.getUserID())}`;

    const data = {
        version: 3,
        method: this.pluginName
    };

    ConnectorRestClient.post(path, data, (purchase) => {
        if (!purchase || !purchase.productId || !purchase.paymentId || !this.getProduct(purchase.productId)) {
            callback(connector.CODE_FAILED);
            return;
        }

        const product = this.getProduct(purchase.productId);

        purchase = this.createPurchase(purchase.paymentId, product, purchase.payload);

        callback(connector.CODE_SUCCEED, purchase);
    }, () => {
        callback(connector.CODE_FAILED);
    });
};

RestPayments.prototype.validate = function (purchase, callback) {
    this.startPurchasePinger(purchase, callback, {
        timeout: connector.utils.parseInterval("3 minutes"),
        timeoutCode: connector.CODE_CANCELLED
    });
};

RestPayments.prototype.consume = function (purchase, callback) {
    this.startPurchasePinger(purchase, (code) => {
        if (code) {
            callback(ERRORS.CONSUME.UNKNOWN);
        } else {
            callback(connector.CODE_SUCCEED);
        }
    }, {
        method: "consume",
        attempts: 5
    });
};

RestPayments.prototype.stopPurchasePinger = function () {
    if (this.purchasePinger) {
        this.purchasePinger.stop();
        delete this.purchasePinger;
    }
};

RestPayments.prototype.startPurchasePinger = function (purchase, callback, options) {
    this.stopPurchasePinger();
    
    callback = connector.utils.once(callback);
    options = options || {};

    const method = options.method || "validate";

    const path = `/payments/${method}/${this.source}/${encodeURIComponent(connector.platform.getUserID())}`;

    const data = {
        purchase,
        version: 5
    };

    this.purchasePinger = new Pinger({
        ...options,
        action: function (callback) {
            ConnectorRestClient.send("POST", path, data, (response) => {
                const code = response.code;
                const data = response.data;

                if (code === "ok") {
                    callback(connector.CODE_SUCCEED, data);
                } else {
                    callback(connector.CODE_PENDING);
                }
            });
        },

        callback: function (code, data) {
            if (code === connector.CODE_SUCCEED) {
                const paymentId = data && data.paymentId;

                if (paymentId && (!purchase.paymentId || RestPayments.IsTmpPaymentId(purchase.paymentId))) {
                    purchase.paymentId = paymentId;
                }
            }

            callback(code, purchase);
        } 
    });
    this.purchasePinger.start();
};

RestPayments.prototype.notifyActive = function () {
    if (this.notifyActiveListener) {
        console.log("Payments notifyActive");
        this.notifyActiveListener();
        delete this.notifyActiveListener;
    }
};

RestPayments.IsTmpPaymentId = function (paymentId) {
    return (`${paymentId}`).startsWith("tmp");
};

RestPayments.prototype.setNotifyActiveListener = function (notifyActiveListener) {
    this.notifyActiveListener = notifyActiveListener;
};

RestPayments.prototype.setPurchaseState = function (purchaseState) {
    if (this.purchaseState !== purchaseState) {
        this.purchaseState = purchaseState;
        this.stopPurchaseActions();

        if (this.purchaseState === undefined) {
            this.bus.trigger("paymentClosed");
        }
    }
};

RestPayments.prototype.stopPurchaseActions = function () {
    this.stopPurchasePinger();

    delete this.notifyActiveListener;
};
